<template>
  <footer class="consent-footer">
    <div class="consent-content">
      <div class="textwidget">
        <a style="margin-right: 30px;" target="_blank" :href="termsUrl">Terms</a>
        <a style="margin-right: 30px;" target="_blank" :href="privacyUrl">Privacy</a>
        <a style="margin-right: 30px;" target="_blank" :href="faqUrl">FAQs</a>
        <a style="margin-right: 30px;" href="javascript:Didomi.preferences.show()" >Consent Preferences</a>

        <span style="font-family: futura; margin-left: 25px">
          Copyright © 2026 CaptivePlay LLC.
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'ConsentFooter',
    data() {
      return {
        isNewUI: false
      }
    },
    computed: {
      termsUrl() {
        return this.isNewUI
          ? 'https://www.freereelslots.com/terms'
          : 'https://www.playpokergo.com/terms'
      },
      privacyUrl() {
        return this.isNewUI
          ? 'https://www.freereelslots.com/privacy'
          : 'https://www.playpokergo.com/privacy'
      },
      faqUrl() {
        return this.isNewUI
          ? 'https://www.freereelslots.com/faq'
          : 'https://www.playpokergo.com/faqs'
      }
    },
    mounted () {
      // 检测是否为新UI（基于域名判断）
      this.isNewUI = window.location.hostname.includes('freereelslots')
    }
  }
</script>

<style scoped>
  .consent-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(14, 40, 73, 0.95);
    color: #fff;
    padding: 10px 0;
    z-index: 1000;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  }
  
  .consent-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
  }
  
  .textwidget {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    font-size: 14px;
    line-height: 1.4;
  }
  
  .textwidget a {
    color: #42b983;
    text-decoration: none;
    transition: color 0.3s ease;
    white-space: nowrap;
  }
  
  .textwidget a:hover {
    color: #359970;
    text-decoration: underline;
  }
  
  /* 桌面端样式 */
  @media (min-width: 769px) {
    /* 保留原有桌面样式 */
  }
  
  /* 移动端样式 */
  @media (max-width: 768px) {
    .consent-footer {
      padding: 8px 0;
    }
    
    .textwidget {
      font-size: 12px;
      line-height: 1.3;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
    
    /* 调整链接间距，让元素尽量在一行显示 */
    .textwidget a[style*="margin-right: 30px"] {
      margin-right: 10px !important;
      margin-left: 10px !important;
    }
    
    /* 调整版权信息间距 */
    .textwidget span[style*="margin-left: 25px"] {
      margin-left: 10px !important;
      margin-right: 10px !important;
    }
  }
  
  /* 小屏幕设备样式 */
  @media (max-width: 480px) {
    .consent-footer {
      padding: 6px 0;
    }
    
    .textwidget {
      font-size: 11px;
    }
    
    .textwidget a[style*="margin-right: 30px"] {
      margin-right: 8px !important;
      margin-left: 8px !important;
    }
    
    .textwidget span {
      margin-top: 4px;
      display: block;
      width: 100%;
    }
  }
  
  /* 小屏幕设备进一步优化 */
  @media (max-width: 480px) {
    .consent-footer {
      padding: 6px 0;
    }
    
    .consent-content {
      padding: 0 10px;
    }
    
    .textwidget {
      font-size: 11px;
    }
    
    .textwidget a[style*="margin-right: 30px"] {
      margin-right: 10px !important;
    }
    
    .textwidget span {
      margin: 4px 0 0 0;
      font-size: 10px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ConsentFooter.vue